import React from 'react';
import styles from './styles.module.css';
import { useCallback } from 'react';
import { SaveApiResMessage } from '@/actions';
import {
  handleCopyableIconClick,
  handleCopyableNameClick,
} from '@/utils/copyableFieldAction';
import { Icons } from '@/assets';
import { ReactSVG } from 'react-svg';

const CONTAINER_COPY_OPTIONS = { label: 'Container Number' };

const ContainerInfoRow = ({ informations, tableData, trackingUrl }) => {
  const data = tableData || {};
  const effectiveTrackingUrl = data.trackingUrl || trackingUrl || '';

  const handleContainerNameClick = useCallback((e, row) => {
    handleCopyableNameClick(e, row.number, CONTAINER_COPY_OPTIONS);
  }, []);

  const handleContainerIconClick = useCallback(
    (e, row) => {
      const url = row.trackingUrl || effectiveTrackingUrl;

      if (!url) {
        SaveApiResMessage({
          title: 'Tracking',
          message: 'No tracking link available for this container.',
          mode: 'warning',
        });
        return;
      }

      handleCopyableIconClick(
        e,
        row.number,
        url,
        CONTAINER_COPY_OPTIONS
      );
    },
    [effectiveTrackingUrl]
  );

  return (
    <div className={styles.infoRow}>
      {informations.map((info, index) => (
        <div
          key={index}
          className={styles.autobookInfoFlexP}
          style={{ flex: info.flex }}>
          <span className={styles.title}>{info.label}: </span>
          {data[info.field] && info.field === 'number' ? (
            <span className={'flex'}>
              <span
                className="cursor-pointer hover:underline"
                onClick={(e) => handleContainerNameClick(e, data)}>
                {data[info.field]}
              </span>{' '}
              <span
                className="cursor-pointer"
                onClick={(e) => handleContainerIconClick(e, data)}>
                <ReactSVG
                  src={Icons.externalLink}
                  className={styles.linkIcon}
                />
              </span>
            </span>
          ) : (
            <span className={styles.value}>{data[info.field] ?? '-'}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default ContainerInfoRow;
